import { Column } from 'typeorm';
import { GenericModel } from '@nsk-app/models/genericModel';

export abstract class OrderedModel extends GenericModel {

  @Column({nullable: true})
  order: number;
}
